import { create } from 'apisauce';

const api = create({    
    baseURL: 'https://vm1.tkgengates.com.br/'
});

// Add an asynchronous request transform for adding the token
api.addAsyncRequestTransform(async (request) => {
    const token = localStorage.getItem('@USER_TOKEN');
    
    if (token) {
        request.headers['Authorization'] = `Bearer ${token}`;
    }
});

export default api;
